/**
 * Announcement Bar Upgrade — Enhanced interactions
 * Dismiss (sessionStorage) + progress bar reset on slide change
 */
(function () {
  'use strict';

  var bar = document.querySelector('.announcement-bar[data-upgrade]');
  if (!bar) return;

  var section = bar.closest('[id^="shopify-section-"]');
  var sectionId = section ? section.id : 'default';

  /* ---- Dismiss ---- */
  if (bar.dataset.dismiss === 'true') {
    var dismissKey = 'ann-x-' + sectionId;

    /* Already dismissed this session — hide immediately */
    if (sessionStorage.getItem(dismissKey)) {
      var outer = bar.closest('height-observer');
      if (outer) outer.style.display = 'none';
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      return;
    }

    var btn = bar.querySelector('.announcement-bar__dismiss');
    if (btn) {
      btn.addEventListener('click', function () {
        /* Set explicit max-height so CSS transition has a start value */
        bar.style.maxHeight = bar.offsetHeight + 'px';
        bar.offsetHeight; /* force reflow */
        bar.classList.add('announcement-bar--dismissing');
        sessionStorage.setItem(dismissKey, '1');
        if (progressObserver) progressObserver.disconnect();

        setTimeout(function () {
          var w = bar.closest('height-observer');
          if (w) w.style.display = 'none';
          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        }, 450);
      });
    }
  }

  /* ---- Progress bar: restart animation on each slide change ---- */
  var progress = bar.querySelector('.announcement-bar__progress');
  var carousel = bar.querySelector('announcement-bar');
  var progressObserver = null;

  if (progress && carousel) {
    progressObserver = new MutationObserver(function () {
      progress.style.animation = 'none';
      progress.offsetHeight; /* reflow */
      progress.style.animation = '';
    });
    progressObserver.observe(carousel, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }
})();

/* ---- Countdown timer custom element ---- */
if (!customElements.get('announcement-countdown')) {
  (function () {
    var instances = new Set();
    var timer = null;

    function tickAll() {
      instances.forEach(function (el) { el._tick(); });
    }

    function startTimer() {
      if (timer) return;
      timer = setInterval(tickAll, 1000);
    }

    function stopTimer() {
      if (instances.size === 0 && timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    var AnnouncementCountdown = function () {
      return Reflect.construct(HTMLElement, [], AnnouncementCountdown);
    };
    AnnouncementCountdown.prototype = Object.create(HTMLElement.prototype);
    AnnouncementCountdown.prototype.constructor = AnnouncementCountdown;

    AnnouncementCountdown.prototype.connectedCallback = function () {
      var dateStr = this.getAttribute('data-date') || '';
      var timeStr = this.getAttribute('data-time') || '00:00';
      this._prefix = this.getAttribute('data-prefix') || '';
      this._expiredText = this.getAttribute('data-expired') || 'Expired';
      this._endTime = new Date(dateStr + 'T' + timeStr).getTime();

      if (isNaN(this._endTime)) {
        this.textContent = this._prefix;
        return;
      }

      instances.add(this);
      this._tick();
      startTimer();
    };

    AnnouncementCountdown.prototype.disconnectedCallback = function () {
      instances.delete(this);
      stopTimer();
    };

    AnnouncementCountdown.prototype._tick = function () {
      var diff = this._endTime - Date.now();

      if (diff <= 0) {
        this.textContent = this._expiredText;
        return;
      }

      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      var parts = '';
      if (d > 0) {
        /* More than 24h — show only days + hours */
        parts += d + 'D ' + String(h).padStart(2, '0') + 'H';
      } else {
        /* 24h or less — show hours (if any) + minutes + seconds */
        if (h > 0) parts += String(h).padStart(2, '0') + 'H ';
        parts += String(m).padStart(2, '0') + 'M ' + String(s).padStart(2, '0') + 'S';
      }

      this.textContent = this._prefix + parts;
    };

    customElements.define('announcement-countdown', AnnouncementCountdown);
  })();
}
